import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";


const Banners = () => 
{ 
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const isNonMobile = useMediaQuery("(min-width:620px)");
    const [isLoading, setIsLoading] = useState(true);
    

    const [bannerData, setBannerData] = useState([{
       bannerId: 0,
       image: "",
    }]);

    const [tabValue, setTabValue] = useState(0);
      const getDecryptedToken = () => {
        const encryptedToken = Cookies.get("token");
        if (!encryptedToken) return null;
    
        const secretKey = '19092002'; 
        const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
        const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    
        return decryptedToken || null;
      };
    
      const token = getDecryptedToken();
      const [searchQuery, setSearchQuery] = useState("");

      const fetchBanner = async (bannerId) => {
        try {
          const response = await axios.get(`${baseURL}/api/Banner/GetBannerById`,{
            params: {id: bannerId},
          });
        
        if (response.data.success){
            setBannerData(response.data);
            setDialogOpen(true);

        }
        else {
            toast.error(response.data.message);
        }
        } catch (error) {
          toast.error(`Error: ${error.message}`);
        }
      };


      const handleFileUpload = (file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setBannerData((prevData) => ({
            ...prevData,
            image: reader.result.split(",")[1], // Base64 image
          }));
        };
        reader.readAsDataURL(file);
      };

      
  const handleEdit = (event) => {
    const { name, value } = event.target;
    setBannerData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSave = async () => {
    if(
        !bannerData.image
    ){
        toast.error("Please add an image!");
    }
  }




      const desktopColumns = [
        { field: "bannerId", headerName: "ID", width: 100 },
        { field: "image", headerName: "Titulli", width: 200 },
      ]

      return (
        <Box m="10px">
          <Header title="Banners" subtitle="Detajet e Banners" />
          <ToastContainer />
          <Box mb={2} display="flex" justifyContent="flex-start">
            
          <Link to="/bannerform" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px"}}
            >
              Shto Banner
            </Button>
          </Link>
          </Box>
            
          <Box
            m="10px 0 0 0"
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .name-column--cell": { color: "#3b0a45" },
              "& .MuiDataGrid-columnHeaders": {
               background: "black",
                borderBottom: "none",
                 color: "#ffffff"
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[500],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: colors.primary[800],
                color: "#ffffff"
               
              },
              "& .MuiButton-root": { color: "#ffffff" },
              "& .super-app-theme--header": {
                backgroundColor: colors.primary[200],
              },
              "& .MuiToolbar-root":{color :"#ffffff"},
              "&. MuiTablePagination-actions": {color: "white"}
    
            }}
          >
          <div sx={{ height: 500, width: "100%" }}>
    
          {isLoading ? (
             
             <Skeleton
               variant="rectangular"
               width="100%"
               height={500}
               animation="wave"
             />
           ) : (
            <DataGrid
              columns={desktopColumns}
              rows={bannerData}
              getRowId={(row) => row.bannerId}
              onRowDoubleClick={(params) => fetchBanner(params.row.bannerId)} 
              components={{ Toolbar: GridToolbar }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
           )}
         </div>
          <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
            
            <DialogContent
                className="custom-dialog-size"
                sx={{ backgroundColor: colors.primary[500], height: isNonMobile ? "" : "50vh",}}
              >
                <div className="tabs-container">
                    <Tabs
                      variant="scrollable"
                      scrollButtons="auto"
                      value = {tabValue}  
                    >
                      <Tab
                        label="Info per banner"
                        sx={{
                          color: "white",
                          backgroundColor: colors.primary[900],
                          margin: "2px",
                          borderRadius: "5px",
                      
                        }}
                      />
                      </Tabs>
                  </div>
                  <div
                        style={{
                          margin: "10px",
                          textAlign: "center",
                          display: isNonMobile ? undefined : "flex",
                          flexDirection: isNonMobile ? "row" : "column",
                        }}
                      >
    
              
                
                
                <TextField
                  label="Banner ID"
                  name="bannerId"
                  value={bannerData.bannerId}
                  onChange={handleEdit}
                  multiline
                  fullWidth
                  margin="dense"
                />
                <Box display="flex" alignItems="center" gap="10px">
                  <TextField
                    
                    type="file"
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                    fullWidth
                    margin="dense"
                    inputProps={{
                      accept: "image/*", // Ensures only image files can be selected
                    }}
                  />
                  <Tooltip title="Image should be 771x170 for the best quality" arrow>
                  <IconButton>
                      <i className="fas fa-info-circle" style={{ color: colors.primary[900] }}></i>
                    </IconButton>
                  </Tooltip>
                </Box>
              </div>
            <DialogActions className="custom-dialog-background">
                    <Button
                      onClick={() => setDialogOpen(false)}
                      sx={{ backgroundColor: "white" }}
                      >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSave}
                      sx={{ backgroundColor: "white" }}
                      >
                      Save
                    </Button>
                  </DialogActions>
                   </DialogContent>    
                    </Dialog>
          </Box>
        </Box>
      );
 }



 export default Banners;